import { Injectable } from '@angular/core';

import {
  IBagCapabilities,
  IUpdateBagsCapabilitiesForm,
  IEditCapabilities,
  ICapabilitiesDetailData,
} from '../../domain/types';

@Injectable()
export class MapBagsCapabilities {
  listBagControlsData(bags: IBagCapabilities[]): IUpdateBagsCapabilitiesForm[] {
    return bags?.reduce((prev, bag) => {
      const parendIndex = prev.length;

      return [
        ...prev,
        {
          id: bag.bagId,
          type: 'BAG',
          parent: null,
          parent_label: '',
          label: bag.name,
          initial_capacity: bag.initial_capacity,
          scheduled: bag.scheduled,
          available: bag.available,
        } as IUpdateBagsCapabilitiesForm,

        ...bag.time_frames.map<IUpdateBagsCapabilitiesForm>((frame) => ({
          id: frame.capability_detail_id,
          type: 'TIME_FRAME',
          parent: parendIndex,
          parent_label: bag.name,
          label: frame.label,
          initial_capacity: frame.initial_capacity,
          scheduled: frame.scheduled,
          available: frame.available,
        })),
      ];
    }, []);
  }

  groupBagsInitialValue(values: IUpdateBagsCapabilitiesForm[]) {
    return values
      ?.filter((value) => value.type !== 'BAG')
      ?.reduce(
        (acum, curr) => {
          const prev = acum[curr.parent] || 0;

          return {
            ...acum,
            [curr.parent]: prev + Number(curr.initial_capacity),
          };
        },
        {} as Record<string, number>,
      );
  }

  calculateInitialCapability(
    values: IUpdateBagsCapabilitiesForm[],
  ): IEditCapabilities {
    return values
      .filter((value) => value.type === 'TIME_FRAME')
      .reduce(
        (prev, curr) => {
          return {
            initial_capacity:
              prev.initial_capacity + Number(curr.initial_capacity),
            available: prev.available + Number(curr.available),
            scheduled: prev.scheduled + Number(curr.scheduled),
          };
        },
        {
          initial_capacity: 0,
          scheduled: 0,
          available: 0,
        } as IEditCapabilities,
      );
  }

  getFormDataBags(
    values: IUpdateBagsCapabilitiesForm[],
  ): ICapabilitiesDetailData[] {
    return values
      ?.filter((value: IUpdateBagsCapabilitiesForm) => value.type !== 'BAG')
      ?.map<ICapabilitiesDetailData>((value: IUpdateBagsCapabilitiesForm) => ({
        id: +value.id,
        totalCapability: +value.initial_capacity,
      }));
  }
}
